module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"seo_favicon":"SEO & favicon","search_engine_optimization":"Search Engine Optimization (SEO)"},"id":{"seo_favicon":"SEO & favicon","search_engine_optimization":"Search Engine Optimization (SEO)"}}')
  delete Component.options._Ctor
}
